import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { environment } from './../../../../../environments/environment';
import { LambdaFunctionService } from '../../../../service/lambda-function.service';

declare var jQuery: any;

@Component({
    selector: 'app-order-details',
    templateUrl: './order-details.component.html',
    styleUrls: ['./order-details.component.scss']
})
export class OrderDetailsComponent implements OnInit, OnDestroy {
    public detail: any;
    public cart: Array<Object> = [];
    public subtotal: string;
    public env: any;
    public print_variable: any;
    public print_invoice: string = 'Print Invoice';
    public print_order: string = 'Print Order';
    discounted_items_price: any;
    args: any;
    download: any = [];
    downloading: boolean = false;
    store: any;
    loading: boolean = false;

    private destroy$ = new Subject<void>();

    constructor(
        private activatedRoute: ActivatedRoute,
        private http: HttpClient,
        public lmda_service: LambdaFunctionService
    ) {}

    ngOnInit() {
        this.loading = true;
        this.store = localStorage.getItem('store');
        this.env = environment;
        this.download[0] = 'Download Creativity Unbound English PDF';
        this.download[1] = 'Download Creativity Unbound French PDF';
        this.download[2] = 'Download Facilitation PDF';
        this.download[3] = 'Download FourSight Toolcards English PDF';
        this.download[4] = 'Download FourSight Toolcards Spanish PDF';
        this.download[5] = 'Download FourSight Toolcards French PDF';
        this.print_variable = 'Order';

        this.activatedRoute.params.pipe(
            takeUntil(this.destroy$),
            switchMap((params) => {
                this.loading = true;
                return this.http.get(`${environment.assessment_admin}api/v1/orders/${params.id}`);
            })
        ).subscribe(
            (res: any) => {
                const order = res['order'];
                this.detail = order;
                this.cart = order['line_items'];
                this.subtotal = order['subtotal_amount'];
                this.discounted_items_price = order['discounted_items_price'];
                this.args = this.buildInvoiceArgs(order);
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                if (error.status === 422) {
                    const msg = error.error?.errors?.base?.[0] || error.error?.errors || 'Something went wrong!';
                    Swal.fire('Oops!', String(msg), 'error');
                } else {
                    Swal.fire('Sorry!', 'Something went wrong!', 'error');
                }
            }
        );
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private buildInvoiceArgs(order: any): any {
        const isPaypalOrFree = order['payment']['payment_method'] === 'paypal' || this.discounted_items_price === 0;
        const needsShipping = order['needs_shipping'] === true;

        return {
            template: 'invoice.html',
            content_type: 'pdf',
            id: order['number'],
            format: 'A4',
            status: order['status'],
            completed_at: order['completed_at'],
            net_amount: order['net_amount'],
            shipping_amount: needsShipping ? order['shipping_amount'] : '',
            tax_amount: order['tax_amount'],
            discounted_items_price: order['discounted_items_price'],
            shipping_method_name: needsShipping ? order['shipping_method_name'] : '',
            payment: { ...order['payment'] },
            credit_card: isPaypalOrFree ? '' : { ...order['credit_card'] },
            line_items: order['line_items'].map((item: any) => ({ ...item })),
            billing_address: { ...order['billing_address'] },
            needs_shipping: order['needs_shipping'],
            shipping_address: needsShipping ? { ...order['shipping_address'] } : ''
        };
    }

    public printPage() {
        jQuery('.navbar-default').hide();
        jQuery('body').addClass('print-body');
        window.print();
        jQuery('.navbar-default').show();
        jQuery('body').removeClass('print-body');
    }

    public printInvoice() {
        this.print_variable = 'Invoice';
        setTimeout(() => {
            jQuery('.navbar-default').hide();
            jQuery('body').addClass('print-body');
            window.print();
        }, 0);
        setTimeout(() => {
            jQuery('.navbar-default').show();
            this.print_variable = 'Order';
            jQuery('body').removeClass('print-body');
        }, 2000);
    }

    public complimentaryPdt() {
        Swal.fire('Hey!', 'This product is a complement to the product above it and cannot be edited independently.', 'success');
    }

    public async lambda(type: string) {
        jQuery('.pdf-modal').css('display', 'block');
        this.args['type'] = type;
        try {
            await this.lmda_service.lambda_invoke('genr-InvoiceFunction-sZf7W6rjtE0H', this.args, type);
        } catch (err) {
            Swal.fire('Sorry!', 'Failed to generate the invoice. Please try again.', 'error');
        }
    }

    public downloadYourMultiPDF(type: string, type_name: string, index: number, quantity: number) {
        if (this.downloading) {
            return;
        }
        jQuery('.pdf-modal').css('display', 'flex');
        let footer = '';
        if (quantity === 1) {
            footer = 'for the exclusive use of one person. Further distribution is a violation of copyright.';
        }
        if (quantity > 1) {
            footer = 'for the exclusive use of one group of ' + quantity + ' people. Further distribution is a violation of copyright.';
        }
        this.downloading = true;
        const name = this.detail['billing_address']['first_name'] + ' ' + this.detail['billing_address']['last_name'];

        try {
            this.lmda_service.lambda_invoke('ebk-EBookFunction-fdg6BBETzLTf', { pdf: type, name: name, footer: footer }, 'Books');
        } catch (err) {
            Swal.fire('Sorry!', 'Failed to download the PDF. Please try again.', 'error');
            this.downloading = false;
            return;
        }

        this.lmda_service.lambda_pdf.pipe(
            takeUntil(this.destroy$)
        ).subscribe(
            (output: any) => {
                if (output['response'] == null) {
                    this.download[index] = type_name;
                }
                this.downloading = false;
            },
            (err: any) => {
                Swal.fire('Sorry!', 'Failed to download the PDF. Please try again.', 'error');
                this.downloading = false;
            }
        );

        setTimeout(() => {
            this.loading = false;
        }, 1000);
    }
}
